import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { PackageTypesDataService, PackageTypesColumnsService } from '../../../services';
import { PackageType, PackageTypesResult } from '../../../interfaces';

@Component({
  selector: 'app-package-type-form',
  templateUrl: './package-type-form.component.html',
  styleUrls: ['./package-type-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class PackageTypeFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public packageType: PackageType = {};
  public packageTypeForm: FormGroup = new FormGroup({});
  public packageTypes: PackageType[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private packageTypesDataService: PackageTypesDataService,
    public packageTypesColumnsService: PackageTypesColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'PackageTypeFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Package Type - Edit');
        this.getPackageType(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.packageType !== 'undefined') {
      this.packageType = this.dynamicDialogConfig.data.packageType;
    }
    if (typeof this.packageType.id === 'undefined' || this.packageType.id === null) {
      this.packageType.id = null;
      this.packageType.isPublished = false;
    }
    this.getPackageTypes();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'PackageTypeFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'PackageTypeFormComponent');
  }

  getPackageType(id: number): void {
    this.isLoading = true;
    this.packageTypesDataService.getPackageType(id).subscribe((response: PackageType|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.packageType = response;
        this.prepareFrom();
      }
    });
  }

  getPackageTypes(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.packageTypes !== 'undefined' && this.dynamicDialogConfig.data.packageTypes.length > 0) {
      this.packageTypes = this.dynamicDialogConfig.data.packageTypes;
      return;
    }
    this.packageTypesDataService.getPackageTypes(this.parameters).subscribe((response: PackageTypesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.packageTypes = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.packageTypeForm = new FormGroup({
      id: new FormControl(this.packageType.id, []),
      name: new FormControl(this.packageType.name, [Validators.required, ]),
      nameAr: new FormControl(this.packageType.nameAr, []),
      nameFr: new FormControl(this.packageType.nameFr, []),
      isPublished: new FormControl(this.packageType.isPublished, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/package-types']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.packageTypeForm.controls).forEach((field: any) => {
        const control = this.packageTypeForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.packageTypeForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.packageType = this.packageTypeForm.value;
    this.disableSubmit = true;
    console.log('packageType', this.packageType);
    if (typeof this.packageType.id !== 'undefined' && this.packageType.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.packageTypesDataService.updatePackageType(this.packageType).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('PACKAGETYPEUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('PACKAGETYPENOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.packageTypesDataService.addPackageType(this.packageType).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('PACKAGETYPECREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('PACKAGETYPENOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-package-type-form',
  templateUrl: './package-type-form.component.html',
  styleUrls: ['./package-type-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogPackageTypeFormComponent extends PackageTypeFormComponent {
}

